module.exports = __webpack_public_path__ + "img/34.632a0b15.jpg";